import { useState } from 'react';
import { ToggleTabs, ToggleTabsButton, ToggleTabsButtonsContainer, ToggleTabsContent } from '../ToggleTabs';
import { ContentContainer, RootContainer, TabsContainer } from './styled';
export function Root(props) {
    const { header, tabs, footer, activeTab: controlledActiveTab, onSelectTab: controlledOnSelectTab } = props;
    const [internalActiveTab, setInternalActiveTab] = useState(tabs[0].key);
    const activeTab = controlledActiveTab !== null && controlledActiveTab !== void 0 ? controlledActiveTab : internalActiveTab;
    const setActiveTab = controlledOnSelectTab !== null && controlledOnSelectTab !== void 0 ? controlledOnSelectTab : setInternalActiveTab;
    return (<RootContainer>
      {header}
      <ToggleTabs activeTab={activeTab} onSelectTab={setActiveTab}>
        <TabsContainer>
          <ToggleTabsButtonsContainer stretch>
            {tabs.map((tab) => (<ToggleTabsButton key={tab.key} tabKey={tab.key}>
                {tab.label}
              </ToggleTabsButton>))}
          </ToggleTabsButtonsContainer>
        </TabsContainer>

        <ContentContainer>
          {tabs.map((tab) => (<ToggleTabsContent key={tab.key} tabKey={tab.key}>
              {tab.content}
            </ToggleTabsContent>))}
        </ContentContainer>
      </ToggleTabs>
      {footer}
    </RootContainer>);
}
